import { render, staticRenderFns } from "./SubstackPostPanel.vue?vue&type=template&id=6fc1689b&scoped=true"
import script from "./SubstackPostPanel.vue?vue&type=script&lang=js"
export * from "./SubstackPostPanel.vue?vue&type=script&lang=js"
import style0 from "./SubstackPostPanel.vue?vue&type=style&index=0&id=6fc1689b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc1689b",
  null
  
)

export default component.exports